export function parameterize(id: number | string, object: {}) {
  return Object.entries(object).reduce((out, [key, value]) => {
    out[`${key}-${id}`] = value;
    return out;
  }, {});
}

export function deparameterize(object: {}) {
  return Object.entries(object).reduce((out, [key, value]) => {
    const originalKey = key.split('-')[0];
    out[originalKey] = value;
    return out;
  }, {});
}



// WEBPACK FOOTER //
// ./src/views/Admin/services/objectHelpers.ts